module.exports = __webpack_public_path__ + "static/media/YF85_02.5a1a9e23.jpg";